<template>
	<div class="network-nav">
		<div class="o-container network-nav__inner">
			<span class="network-nav__text-logo">footb<i class="network-nav__brand-color-text">all</i></span>
			<span class="network-nav__subtext-logo">Network</span>
			<ul class="network-nav__menu">
				<li class="network-nav__item">
					<a href="https://www.myfootball.com.au" class="network-nav__link">My Football</a>
				</li>
				<li class="network-nav__item">
					<a href="https://www.playfootball.com.au" class="network-nav__link">Play Football</a>
				</li>
				<li class="network-nav__item">
					<a href="https://www.footballaustralia.com.au" class="network-nav__link">Football Australia</a>
				</li>
				<li class="network-nav__item">
					<a href="https://www.playfootball.com.au/miniroos" class="network-nav__link">MiniRoos</a>
				</li>
			</ul>

			<div
				class="network-nav__user-menu-wrapper"
				v-if="user"
				@mouseenter="toggleDropdown(true)"
				@mouseleave="toggleDropdown(false)"
				@click="toggleDropdownMobile(!dropdownIsVisible)"
				@touchstart.stop=""
			>
				<div class="network-nav__user-menu-header">
					<div 
						class="network-nav__right-logo"
						:class="{'network-nav__right-logo--plus': isPlusUser}"
					></div>
					<div 
						class="network-nav__right-text"
						:class="{'network-nav__right-text--plus': isPlusUser}"
					>{{ user.given_name }} {{ user.family_name }}</div>
					<div
						:class="[
							'network-nav__chevron',
							{'is-opened': dropdownIsVisible},
							{'network-nav__chevron--plus': isPlusUser}
						]"
					><i class="chevron chevron--bottom chevron--small"></i></div>
				</div>

				<div class="network-nav__dropdown-wrapper" :style="dropdownWrapperStyle">
					<ul class="network-nav__user-menu-list" ref="dropdownMenu">
						<li class="network-nav__user-menu-item">
							<router-link
								:to="{name: 'myAccount'}"
								class="network-nav__user-menu-link"
							>My Account</router-link>
						</li>
						<li v-show="user.isRegoUser" class="network-nav__user-menu-item">
							<a
								target="_blank"
								class="network-nav__user-menu-link"
								href="https://registration.playfootball.com.au/participant?page=profile"
							>My Registration</a>
						</li>
						<li class="network-nav__user-menu-item">
							<a
								class="network-nav__user-menu-link"
								@click="signOut"
							>Sign Out</a>
						</li>
					</ul>
				</div>
			</div>

			<div class="network-nav__user-menu-wrapper" v-else>
				<router-link
					class="network-nav__user-menu-header"
					:to="{name: 'register'}"
				>
					<div class="network-nav__right-logo"></div>
					<div class="network-nav__right-text">
						My accounts
					</div>s
				</router-link>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapState } from 'vuex';
	import SlideDown from '../animations/SlideDown.vue'
	import modernizr from 'modernizr';

	export default {
		components: {
			SlideDown
		},
		data() {
			return {
				dropdownIsVisible: false,
				dropdownWrapperStyle: {
					maxHeight: 0
				}
			};
		},
		computed: {
			...mapState('user', {
				user: state => state.user
			}),
			isPlusUser() {
				return this.user && (this.user.accountType === 'Plus' || this.user.accountType === 'Plus+');
			}
		},
		watch: {
			dropdownIsVisible() {
				if (this.dropdownIsVisible) {
					this.dropdownWrapperStyle.maxHeight = this.$refs.dropdownMenu.offsetHeight + 'px';
				} else {
					this.dropdownWrapperStyle.maxHeight = 0;
				}
			},
			user() {
				if (!this.user) {
					this.dropdownIsVisible = false;
					this.dropdownWrapperStyle.maxHeight = 0;
				}
			}
		},
		created() {
			document.body.addEventListener('touchstart', this.touchStart);
		},
		methods: {
			signOut() {
				this.$store.dispatch('user/LOGOUT').then(() => {
					// OAuth path: cognito.js logout() already called window.location.href = buildLogoutUrl()
					// which navigates to auth-ui /logout to clear the SSO session.
					// Calling router.push here would trigger beforeEach → prompt=none SSO redirect,
					// overriding the logout navigation and silently re-authenticating the user.
					if (!window.OAuthConfig?.enabled) {
						this.$router.push({name: 'login'});
					}
				});
			},
			toggleDropdown(value) {
				if (!modernizr.touchevents) {
					this.dropdownIsVisible = value;
				}
			},
			toggleDropdownMobile(value) {
				if (modernizr.touchevents) {
					this.dropdownIsVisible = value;
				}
			},
			touchStart() {
				this.dropdownIsVisible = false;
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import "~sass/_config.scss";
	@import '~sass/_variables.scss';
	@import "~sass/mixins/_media-query.scss";

	.network-nav {
		$b: &;

		position: relative;
		background-color: $col-t--1;
		height: 40px;
		box-shadow: 0px -1px 4px 2px rgba(0, 0, 0, 0.3);

		&__inner {
			height: 100%;
			display: flex;
			align-items: center;
		}

		&__text-logo {
			font-size: 16px;
			line-height: 24px;
			font-weight: 800;
			text-transform: uppercase;
			color: $networkNavTxtColor;
		}

		&__subtext-logo {
			font-size: 13px;
			color: $col-neutral--0;
			font-weight: 600;
			padding-left: 7px;
			border-right: none;
			padding-right: 30px;
			margin-right: 30px;

			@include mq(tablet) {
				border-right: 1px solid rgba(255, 255, 255, 0.3);
			}
		}

		&__brand-color-text {
			color: $col-neutral--0;
			font-style: normal;
		}

		&__alter-color {
			color: $col-neutral--0;
		}

		&__link {
			text-decoration: none;
			color: $col-neutral--0;
			font-size: 12px;
			font-weight: 600;
			display: flex;
			align-items: center;
			transition-duration: $ttime;

			&:hover {
				opacity: 0.8;
			}
		}

		&__menu {
			display: none;
			list-style: none;

			@include mq(tablet) {
				display: flex;
			}
		}

		&__item {
			@include mq(tablet) {
				margin-right: 25px;
				display: flex;
				align-items: center;
				overflow: hidden;

				&:last-child {
					margin-right: 0;
				}
			}
		}

		&__user-menu-wrapper {
			height: 100%;
			margin-left: auto;
			position: relative;
			min-width: 0;
		}

		&__user-menu-header {
			display: flex;
			padding: 0 15px;
			height: 100%;
			align-items: center;
			cursor: pointer;
			text-decoration: none;
			transition: opacity $ttime;

			&:hover {
				opacity: 0.9;
			}
		}

		&__right-logo {
			width: 22px;
			height: 22px;
			background-size: contain;
			background-position: 50% 50%;
			background-repeat: no-repeat;
			background-image: url('../../../img/NetworkNavigation/img--avatar-logo@2x.svg');
			margin-right: 10px;
			min-width: 14px;

			&--plus {
				position: relative;
				
				&::before {
					content: '';
					position: absolute;
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;
					background-color: #FFD700;
					mask: url('../../../img/NetworkNavigation/img--avatar-logo@2x.svg') no-repeat center;
					mask-size: contain;
					-webkit-mask: url('../../../img/NetworkNavigation/img--avatar-logo@2x.svg') no-repeat center;
					-webkit-mask-size: contain;
				}
			}
		}

		&__right-text {
			font-size: 12px;
			line-height: 14px;
			color: $col-neutral--0;
			font-weight: 600;
			flex-shrink: 1;
			word-wrap: break-word;
			min-width: 0;

			&--plus {
				color: #FFD700; /* Gold color for Plus+ users */
				text-shadow: 0 0 2px rgba(255, 215, 0, 0.3); /* Subtle glow effect */
			}
		}

		&__transparent-text {
			opacity: 0.6;
		}

		&__chevron {
			color: $col-neutral--0;
			margin-left: 5px;
			transition: transform $ttime;

			& > .chevron::after {
				width: 25%;
				height: 25%;
			}

			&--plus {
				color: #FFD700; /* Gold color for Plus+ users */
			}
		}

		&__dropdown-wrapper {
			height: 9999px;
			position: relative;
			overflow: hidden;
			transition: max-height $ttime * 2;
		}

		&__user-menu-list {
			position: absolute;
			bottom: 0;
			color: $col-neutral--0;
			font-size: 12px;
			line-height: 13px;
			font-weight: 600;
			left: 0;
			right: 0;
		}

		&__user-menu-item {
			background-color: $networkNavBgColor;
			border-bottom: 1px solid #00004b;
			transition: background-color $ttime;

			&:first-child {
				border-top: 1px solid #00004b;
			}

			&:last-child {
				border-bottom: none;
			}
			
			&:hover {
				background-color: darken($col-t--1, 10%);
			}
		}

		&__user-menu-link {
			display: block;
			padding: 13px 15px;
			color: currentColor;
			text-decoration: none;
			cursor: pointer;

		}
	}
</style>